<template>
	<div class="display-inline-flex align-items-center">
		<span v-if="icon" :class="`container-icon-description ${icon}`">
			<span :class="`sprite-icons ${icon}`"></span>
		</span>
		<span class="key-description">{{ label }}:</span>
		<span class="value-description">{{ description }}</span>
	</div>
</template>

<script>
export default {
	name: 'detail-description',
	props: {
		icon: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		description: {
			type: [Date, String, Number],
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.container-icon-description {
		border-radius: 100%;
		display: inline-block;
		font-size: inherit;
		height: 17px;
		letter-spacing: inherit;
		line-height: inherit;
		padding-top: 0px;
		text-align: center;
		width: 17px;

		&.type-clean {
			background-color: map-get($colors, clean-type);
		}

		&.date {
			background-color: map-get($colors, date);
		}

		&.time-standard {
			background-color: map-get($colors, standartime);
		}

		&.time-done {
			background-color: map-get($colors, done-time);
		}

		&.supervisor {
			background-color: map-get($colors, default-blue);
		}
	}

	.key-description {
		color: map-get($colors, realtime-label);
		font-family: map-get($fonts, regular);
		font-size: map-get($sizes, fourteen);
		line-height: inherit;
		margin: 0px 2px 0px 5px;
		padding-top: 0px;
	}

	.value-description {
		color: map-get($colors, default-dark);
		font-family: map-get($fonts, regular);
		font-size: map-get($sizes, fourteen);
		line-height: inherit;
		padding-top: 0px;
		text-transform: capitalize;
	}
</style>



// WEBPACK FOOTER //
// DetailDescription.vue?54b0a119